import { createContext } from 'react';
import { I18nProviderShape } from 'automation-ui-i18n/propTypes';
const I18nContext = /*#__PURE__*/createContext({});
I18nContext.Provider.propTypes = {
  value: I18nProviderShape.isRequired
};
export const I18nProvider = I18nContext.Provider;
export const I18nConsumer = I18nContext.Consumer;